import React from 'react'

import Skeleton from 'react-loading-skeleton'

const GoogleAdSkeleton = () => {
  return (
    <div style={{ margin: '30px 0' }}>
      <Skeleton height={120} />
    </div>
  )
}

export default GoogleAdSkeleton
